import { render, staticRenderFns } from "./FaultGroupSelector.vue?vue&type=template&id=5b4fefe8&scoped=true"
import script from "./FaultGroupSelector.vue?vue&type=script&lang=js"
export * from "./FaultGroupSelector.vue?vue&type=script&lang=js"
import style0 from "./FaultGroupSelector.vue?vue&type=style&index=0&id=5b4fefe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4fefe8",
  null
  
)

export default component.exports